import api from './api';
import { trackPromise } from 'react-promise-tracker';
import { getJwt } from '@app/helpers';
import Axios from 'axios';

export const GetRelatorioControleGastos = (filter: any) =>
  api.post('relatorios/relatorioClassificacaoGastos', filter, { disableNotification: 'true' });

export const GetRelatorioControleGastosExcel = (filter: any) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.post(urlBase + `/api/relatorios/relatorioClassificacaoGastos/excel`, filter, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorio_classificacao_gastos.xlsx');
      link.setAttribute('id', 'downloadrelatorio_classificacao_gastos');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadrelatorio_classificacao_gastos').outerHTML = '';
    }),
  );
};
